import i18n from 'i18next';

export function getModalText(error) {
    const statusCode = error.errorCode;
    const dataBody = error.dataBody;
    const message = {};
    let messageKind = error.dataCall;
    let title = null;
    let description = null;

    if (statusCode === 401) {
        messageKind = 'Unauthorized';
    }
    // Feature Events
    if (messageKind === 'putFeaturedContent') {
        if ((dataBody === true) && (statusCode !== 400)) {
            messageKind = 'putFeatured';
        } else if ((dataBody === false) && (statusCode !== 400)) {
            messageKind = 'putUnfeatured';
        }
    }
    // Create Groups
    if (messageKind === 'createGroup') {
        if (dataBody === 'Duplicate Group Name') {
            messageKind = 'duplicateGroup';
        }
        if (dataBody === 'Maximum group count reached') {
            messageKind = 'maximumGroupCount';
        }
    }

    switch (messageKind) {
    case 'putFeaturedContent': {
        title = i18n.t('CatalogCard.feature-limit-exceeded-title');
        description = {__html: i18n.t('CatalogCard.feature-limit-exceeded-message')};
    }
        break;
    case 'putFeatured': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('CatalogCard.error-message-feature')};
    }
        break;
    case 'putUnfeatured': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('CatalogCard.error-message-unfeature')};
    }
        break;
    case 'putChannelTitle': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('channel.errors.title-update-error')};
    }
        break;
    case 'putChannelDescription': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('channel.errors.description-update-error')};
    }
        break;
    case 'putChannelTheme': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('channel.errors.theme-update-error')};
    }
        break;
    case 'putChannelBanner': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('channel.errors.banner-update-error')};
    }
        break;
    case 'putChannelLogo': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('channel.errors.logo-update-error')};
    }
        break;
    case 'putRecordingTitle': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('channel.errors.edit-recording-title-error')};
    }
        break;
    case 'postContentThumbnail': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('CatalogCard.thumbnail-update-error')};
    }
        break;
    case 'putContentCategory': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('CatalogCard.category-update-error')};
    }
        break;
    case 'Unauthorized': {
        title = i18n.t('error.session-timeout');
        description = {__html: i18n.t('error.invalid-access-token-message')};
    }
        break;
    case 'putContentAttribute': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('watchNow.description-update-error')};
    }
        break;
    case 'deleteContentThumbnail': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('CatalogCard.thumbnail-remove-error')};
    }
        break;
    case 'createGroup': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('groups.errors.create-group-error')};
    }
        break;
    case 'duplicateGroup': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('groups.errors.duplicate-group-error')};
    }
        break;
    case 'maximumGroupCount': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('groups.errors.maximum-group-count-error')};
    }
        break;
    case 'deleteGroup': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('groups.errors.delete-group-error')};
    }
        break;
    case 'putChannelGroup': {
        title = i18n.t('error.sorry-title');
        if (dataBody && dataBody === 'Duplicate Group Name') {
            description = {__html: i18n.t('groups.errors.duplicate-group-error')};
        } else if (dataBody && dataBody === 'Group Name cannot be general') {
            description = {__html: i18n.t('groups.errors.group-name-cannot-be-general')};
        } else {
            description = {__html: i18n.t('groups.errors.update-group-name-error')};
        }
    }
        break;
    case 'moveContentToAnotherGroup': {
        title = i18n.t('error.sorry-title');
        if (dataBody && dataBody === 'Max limit reached for contents') {
            description = {__html: i18n.t('groups.errors.dragAndDrop.max-limit')};
        } else {
            description = {__html: i18n.t('groups.errors.dragAndDrop.generic')};
        }
    }
        break;
    case 'moveContentWithinGroup': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('groups.errors.dragAndDrop.same-group')};
    }
        break;
    case 'putChannelMoveGroups': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('groups.errors.move-group-error')};
    }
        break;
    case 'setUserSetting': {
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('privacy-setting.errors.privacy-update-error')};
    }
        break;
    default:
        title = i18n.t('error.sorry-title');
        description = {__html: i18n.t('error.default-error')};
        break;
    }
    message.title = title;
    message.description = description;
    return message;
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/message-banner-helper.js